import { render, staticRenderFns } from "./edit-conference.vue?vue&type=template&id=0c2f8c7f&"
import script from "./edit-conference.vue?vue&type=script&lang=js&"
export * from "./edit-conference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports